"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 *
 *@description:     tip 提示语弹窗
 *@modifyContent:
 *@author: qiuhongyang
 *@date: 2020-09-22 09:53:25
 *
*/
require("./style.less");
;
var tiptoast = {
    show: function (opt) {
        var defaultopt = {
            content: "",
            callback: null,
            showtime: 3000,
            classStyle: "tiptoastmodal",
            boxid: "body"
        };
        var options = $.extend({}, defaultopt, opt);
        $("." + "".concat(options.classStyle)).remove();
        var htmlstr = "<div class=\"".concat(options.classStyle, "\">").concat(opt.content, "</div>");
        $(options.boxid).append($(htmlstr));
        if (options.callback) {
            setTimeout(function () {
                options.callback();
            }, options.showtime);
        }
        $("." + "".concat(options.classStyle)).fadeOut(options.showtime);
    }
};
exports.default = tiptoast;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGlwdG9hc3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0aXB0b2FzdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBOzs7Ozs7O0VBT0U7QUFDRix3QkFBc0I7QUFJckIsQ0FBQztBQUVGLElBQUksUUFBUSxHQUFHO0lBQ2IsSUFBSSxZQUFDLEdBQVE7UUFDWCxJQUFJLFVBQVUsR0FBRztZQUNmLE9BQU8sRUFBRSxFQUFFO1lBQ1gsUUFBUSxFQUFFLElBQUk7WUFDZCxRQUFRLEVBQUUsSUFBSTtZQUNkLFVBQVUsRUFBRSxlQUFlO1lBQzNCLEtBQUssRUFBRSxNQUFNO1NBQ2QsQ0FBQTtRQUNELElBQUksT0FBTyxHQUFRLENBQUMsQ0FBQyxNQUFNLENBQUMsRUFBRSxFQUFFLFVBQVUsRUFBRSxHQUFHLENBQUMsQ0FBQztRQUNqRCxDQUFDLENBQUMsR0FBRyxHQUFHLFVBQUcsT0FBTyxDQUFDLFVBQVUsQ0FBRSxDQUFDLENBQUMsTUFBTSxFQUFFLENBQUM7UUFFMUMsSUFBSSxPQUFPLEdBQUcsdUJBQWUsT0FBTyxDQUFDLFVBQVUsZ0JBQUssR0FBRyxDQUFDLE9BQU8sV0FBUSxDQUFBO1FBQ3ZFLENBQUMsQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDO1FBRXBDLElBQUksT0FBTyxDQUFDLFFBQVEsRUFBRTtZQUNwQixVQUFVLENBQUM7Z0JBQ1QsT0FBTyxDQUFDLFFBQVEsRUFBRSxDQUFDO1lBQ3JCLENBQUMsRUFBRSxPQUFPLENBQUMsUUFBUSxDQUFDLENBQUM7U0FDdEI7UUFDRCxDQUFDLENBQUMsR0FBRyxHQUFHLFVBQUcsT0FBTyxDQUFDLFVBQVUsQ0FBRSxDQUFDLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUU3RCxDQUFDO0NBRUYsQ0FBQTtBQUVELGtCQUFlLFFBQVEsQ0FBQyJ9